import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "logos-wr"
}
const _hoisted_2 = { class: "logo-img-wr" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header-with-estate-logo-desktop", { 'is-first-step': $props.currentStep === $setup.BuilderEstimatorSteps.LAND_DETAILS }])
  }, [
    ($props.currentStep !== $setup.BuilderEstimatorSteps.LAND_DETAILS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: $props.builderLogo,
              alt: "Builder Logo"
            }, null, 8, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode($setup["BuilderDesktopStepIndicator"], {
      steps: $props.steps,
      currentStep: $props.currentStep,
      errorOnCurrentStep: $props.errorOnCurrentStep,
      isNotFirstStep: $props.currentStep !== $setup.BuilderEstimatorSteps.LAND_DETAILS,
      houseDesign: $props.houseDesign,
      onSelectNext: $setup.onSelectNext,
      onSelectPrev: $setup.onSelectPrev
    }, null, 8, ["steps", "currentStep", "errorOnCurrentStep", "isNotFirstStep", "houseDesign"]),
    ($props.currentStep !== $setup.BuilderEstimatorSteps.LAND_DETAILS)
      ? (_openBlock(), _createBlock($setup["BuilderEstimatorQuoteSummaryCollapsed"], {
          key: 1,
          "total-price": $props.totalPrice,
          onToggleSummaryModal: $setup.onToggleSummaryModal
        }, null, 8, ["total-price"]))
      : _createCommentVNode("", true)
  ], 2))
}